import * as Api from './../api';
import {
  FETCH_BANKS_SUCCESS,
  FETCH_CARDS_SUCCESS,
  FETCH_COMPANIES_SUCCESS,
  FETCH_TAGS,
  PATCH_TAGS,
} from './../constants';

export function fetchCardsSuccess(data: any[]): any {
  return {
    data,
    type: FETCH_CARDS_SUCCESS,
  };
}

export function fetchBanksSuccess(data: any[]): any {
  return {
    data,
    type: FETCH_BANKS_SUCCESS,
  };
}

export function fetchCompaniesSuccess(data: any[]): any {
  return {
    data,
    type: FETCH_COMPANIES_SUCCESS,
  };
}

export function fetchCards(): any {
  return (dispatch: any) => {
    return Api.listCards()
      .then((results) => {
        dispatch(fetchCardsSuccess(results.data));
      });
  };
}

export function fetchBanks(): any {
  return (dispatch: any) => {
    return Api.listBanks()
      .then((results) => {
        dispatch(fetchBanksSuccess(results.data));
      });
  };
}

export function fetchCompanies(): any {
  return (dispatch: any) => {
    return Api.listCompanies()
      .then((results) => {
        dispatch(fetchCompaniesSuccess(results.data));
      });
  };
}

export function patchTags(data: any): any {
  return {
    data,
    type: PATCH_TAGS,
  };
}

export function fetchTagsSuccess(data: any[]): any {
  return {
    data,
    type: FETCH_TAGS,
  };
}

export function fetchTags(): any {
  return (dispatch: any) => {
    return Api.getTags({ limit: 3000, order: 'id desc' })
      .then((res) => dispatch(fetchTagsSuccess(res.data)));
  }
}



// WEBPACK FOOTER //
// ./src/actions/index.ts